import React, { FC } from 'react';
import { Text, TextProps } from '@bechtel/gds';
import { OverflowEllipsisProps, EllipsisPlacement } from './types';

type TextWithEllipsisProps = TextProps & OverflowEllipsisProps;
export const TextWithEllipsis: FC<TextWithEllipsisProps> = ({
  ellipsisPlacement = EllipsisPlacement.BEGINNING,
  ...props
}) => {
  //Used style prop in favor of css prop to facilitate unit test cases. For some reason values specified in css prop is not reflecting in jest.
  return (
    <Text
      data-testid="text-box"
      style={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        lineHeight: 'normal',
        direction: ellipsisPlacement === EllipsisPlacement.BEGINNING ? 'rtl' : 'ltr',
        unicodeBidi: 'plaintext',
      }}
      {...props}
    ></Text>
  );
};
